<template>
  <section class="group">
    <sumup-widget v-if="providerTypeId === 1" :checkout="checkout" @completed="onComplete" @errored="onError" @cancelled="onCancel" />
    <lopay-widget v-else-if="providerTypeId === 2" :reference="reference" :checkout="checkout" @completed="onComplete" @cancelled="onCancel" />
  </section>
</template>

<script>
import SumUpWidget from './Widgets/SumUpWidget.vue'
import LopayWidget from './Widgets/LopayWidget.vue'

export default {
  name: 'PaymentProcessor',
  props: {
    checkout: {
      type: Object,
      required: true
    },
    reference: String
  },
  computed: {
    providerTypeId () {
      return this.checkout.providerType.id
    }
  },
  methods: {
    onCancel () {
      this.$emit('cancelled')
    },
    onComplete () {
      this.$emit('completed')
    },
    onError (message) {
      this.$emit('completed', message)
    }
  },
  components: {
    'sumup-widget': SumUpWidget,
    'lopay-widget': LopayWidget
  }
}
</script>
